export default __webpack_public_path__ + "static/media/truck-delivery.1d26198f.svg";